import Vue from 'vue'
import VueRouter from 'vue-router'

import NoFound from "../views/NoFound"
import Index from "../views/Index"

Vue.use(VueRouter); //使用插件

export const routes = [
  { //一级路由
    path: '/', // 根路由 
    name: 'index',
    component: Index,
    meta:{//初始化的meta
      isShow:true,
      title:'',
      content:{
        title:'',
        keywords:'',
        description:'',
      }
    },
  },
  {
    path: '/service',
    name: 'MarketingPromotion',
    component: () => import('@/views/MarketingPromotion.vue'),
    meta: { isShow: true, title: '营销传播' },
  },
  {
    path: '/activity',
    name: 'ActivityPlanning',
    component: () => import('@/views/ActivityPlanning.vue'),
    meta: { isShow: true, title: '活动策划' },
  },
  {
    path: '/overall',
    name: 'OverallService',
    component: () => import('@/views/OverallService.vue'),
    meta: { isShow: true, title: '综合服务' },
  },
  {
    path: '/aboutus',
    name: 'AboutUs',
    component: () => import('@/views/AboutUs.vue'),
    meta: { isShow: true, title: '关于我们' },
  },
  // {
  //   path: '/aboutus',
  //   name: 'aboutus',
  //   component: AboutUs,
  // },
  {
    path: '*',
    component: NoFound
  }
]

const router = new VueRouter({
  routes,
  mode: 'hash' //路由匹配模式  hash 
})

/* 
  权限控制：把不需要登录的页面 称为 白名单 

*/

export default router
